export default __webpack_public_path__ + "static/media/if-you-know-what-i-mean-127.1e0440da.png";